module.exports = __webpack_public_path__ + "media/images/gallery/constellations/figure_layer_off-5dc56aae52fb562cdc3dd2ba8b665729.jpg";